<template>
  <section :class="$options.name" v-scroll="handleScroll">
    <span :class="$options.name + '__img--wrapper'">
      <figure :class="$options.name + '__img'">
        <img v-if="img" :src="img + '?fm=jpg&fl=progressive&f=face&fit=fill&w=720&h=416'" :alt="'Image for ' + title + ' service'"/>
        <Loader v-else/>
      </figure>
    </span>
    <figcaption :class="$options.name + '__caption'">
      <h3>{{ title }}</h3>
      <h4>{{ subtitle }}</h4>
      <RichText :class="$options.name + '__caption--description'" :value="description"/>
    </figcaption>
  </section>
</template>
<script>
import Loader from "@/components/Loader";
import RichText from "@/components/RichText";
export default {
  name: "Service",
  components: { Loader, RichText },
  methods: {
    handleScroll(evt, el) {
      let position = el.getBoundingClientRect();
      let top = position.top;
      if (window.scrollY > top - 64) {
        el.classList.add("scrolled");
      }
    }
  },
  props: {
    img: { default: '' },
    description: { default: "Description" },
    subtitle: { default: "Subtitle" },
    title: { default: "Title" }
  }
};
</script>
<style lang="scss">
.Service {
  align-items: center;
  background-color: var(--contrast);
  border-radius: rem(4);
  box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.25);
  display: flex;
  flex-wrap: wrap;
  margin: rem(16) auto;
  max-width: rem(1440);
  overflow: hidden;
  > * {
    flex-grow: 1;
    @include breakpoint(m) {
      flex-basis: 45%;
      max-width: 50%;
    }
  }
  &__img {
    @include smooth;
    background-color: var(--base);
    transform: translateY(rem(-32));
    .scrolled & {
      transform: translateY(0);
    }
    &--wrapper {
      overflow: hidden;
    }
    img {
      width: 100%;
    }
  }
  &__caption {
    @include smooth;
    padding: rem(16);
    transform: translateY(rem(16));
    @include breakpoint(s) {
      padding: rem(32);
    }
    .scrolled & {
      transform: translateY(0);
    }
    h4 {
      color: var(--base-mid);
    }
    &--description {
      margin-top: rem(16);
    }
  }
  &:nth-of-type(even) {
    .Service__caption {
      @include breakpoint(m) {
        order: -1;
      }
    }
  }
}
</style>